<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g transform="translate(-13 -1379)">
            <g transform="translate(-2 1063)">
                <circle class="a" cx="17" cy="17" r="17" transform="translate(15 316)" 
                :fill="this.$vuetify.theme.dark ? '#A5D867' : '#ffffff'"/>
            </g>
            <text class="b" transform="translate(30.5 1402)" fill="#383935" font-size="18px" font-family="Museo-Sans" font-weight="700">
                <tspan x="-4.383" y="0">?</tspan>
            </text>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'FaqIcon'
}
</script>

<style scoped>
    svg {
        width:34px;
        height: 34px;
    }
</style>